import { Component, input, output, ElementRef, Renderer2, AfterViewInit, OnDestroy, effect, Input, signal, Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-gallery-viewer',
  imports: [],
  templateUrl: './gallery-viewer.html',
  styleUrl: './gallery-viewer.scss',
})
export class GalleryViewer implements AfterViewInit, OnDestroy {
  isOpen = input<boolean>(false);
  images = input<string[]>([]);
  @Input() imageIndex = 0;
  direction: 'next' | 'prev' = 'next';
  leaving = signal(false);
  isFullscreen = signal(false);

  close = output<void>();

  private modalElement: HTMLElement | null = null;
  private isBrowser: boolean;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    // Watch for isOpen changes and handle body overflow
    effect(() => {
      if (this.isBrowser) {
        if (this.isOpen()) {
          this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
        } else {
          this.renderer.removeStyle(this.document.body, 'overflow');
        }
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.isBrowser) {
      // Move modal to body to escape parent container constraints
      this.modalElement = this.elementRef.nativeElement;
      if (this.modalElement) {
        this.renderer.appendChild(this.document.body, this.modalElement);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.isBrowser) {
      // Clean up: remove modal from body and restore scroll
      if (this.modalElement && this.modalElement.parentNode) {
        this.renderer.removeChild(this.document.body, this.modalElement);
      }
      this.renderer.removeStyle(this.document.body, 'overflow');
    }
  }

  onClose(): void {
    this.close.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  onNext(): void {
    this.direction = 'next';
    this.leaving.set(true);
    setTimeout(() => {
      if (this.imageIndex < this.images().length - 1) {
        this.imageIndex++;
      }
      this.leaving.set(false);
    }, 300);
  }

  onPrevious(): void {
    this.direction = 'prev';
    this.leaving.set(true);
    setTimeout(() => {
      if (this.imageIndex > 0) {
        this.imageIndex--;
      }
      this.leaving.set(false);
    }, 300);
  }

  onFullscreen(): void {
    if (!this.isBrowser) return;

    this.isFullscreen.set(!this.isFullscreen());
    if (this.isFullscreen()) {
      // request full screen
      this.elementRef.nativeElement.requestFullscreen();
    } else {
      // exit full screen
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      }
    }
  }
}
